module.exports = __webpack_public_path__ + "platinum_badge.webp";